import { css } from 'styled-components';

export const mobileSize = 375;
export const breakpoint = 530;

export const SizeToRem = (size) => `calc(${size}rem/16)`;

const ThemeStyle = {
  color: {
    orangePink: '#ff6452',
    brownGrey: '#929292',
    background: '#ffffff', // 이름 임의 지정
    darkest: '#161616', // 이름 임의 지정
    pinkishGrey: '#c7c7c7',
    caption: '#555', // 이름 임의 지정
    black: '#231815',
  },
  background: {
    white: '#ffffff',
    grey: '#f6f6f6',
  },
  typography: {
    size: {
      9: SizeToRem(9),
      10: SizeToRem(10),
      12: SizeToRem(12),
      14: SizeToRem(14),
      16: SizeToRem(16),
      18: SizeToRem(18),
      20: SizeToRem(20),
      24: SizeToRem(24),
      28: SizeToRem(28),
      32: SizeToRem(32),
      40: SizeToRem(40),
      48: SizeToRem(48),
    },
    weight: {
      regular: '400',
      medium: '500',
      bold: '700',
    },
  },
};

export default ThemeStyle;

export const FontSize = css`
  font-size: ${(props) => SizeToRem(props.size)};
`;
